import { Language } from './interfaces';

export type GenderId = 'men' | 'women' | 'unisex' | 'not_applicable';

export function genderQueryToGenderId(query: string | undefined): GenderId | undefined {
    if (!query) {
        return undefined;
    }

    query = query.toLowerCase();

    if (query === 'men' || query === 'women' || query === 'unisex' || query === 'not_applicable') {
        return query;
    }

    if (query === 'herre' || query === 'man') {
        return 'men';
    }

    if (query === 'dame' || query === 'woman') {
        return 'women';
    }
}

// yes this is duplicated code from the gatsby-node file!
const sexyTable: { [key: string]: { [key: string]: string } } = {
    nb: {
        men: 'Herre',
        women: 'Dame',
        unisex: 'Unisex',
        not_applicable: 'not_applicable',
    },
    en: {
        men: 'Man',
        women: 'Woman',
        unisex: 'Unisex',
        not_applicable: 'not_applicable',
    },
};

export function translateGender(gender: GenderId, language: Language): string {
    return sexyTable[language][gender];
}
